import React from 'react';

import { Box, BoxProps } from '@mui/material';

import { useSidePanel } from '~/contexts/SidePanelContext';
import * as LAYOUT from '~/pages/layout';

interface ITabPanelProps extends Omit<BoxProps, 'ref' | 'role'> {
  children?: React.ReactNode;
  value: string;
}

export const TabPanel: React.FC<ITabPanelProps> = (props) => {
  const { children, value, sx, ...others } = props;
  const { tab } = useSidePanel();
  const display = tab !== value ? 'none' : 'flex';
  return (
    <Box
      role="tabpanel"
      sx={[
        LAYOUT.CONTAINER,
        LAYOUT.BODY,
        {
          display,
          pb: 1,
          '> *': {
            px: 2,
            '&:first-of-type': {
              pt: 2,
            },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others}
    >
      {children}
    </Box>
  );
};
